import React from 'react'
import {connect} from 'react-redux'
import { AbstractConstantCustomFieldViewComponent, mapStateToProps } from './abstract'
import {Header} from '~/components/header'
import * as route from '~/helper/constant/route'
import { Sidebar } from '~/components/sidebar'
import { withTranslation } from 'react-i18next'
import { Table } from '~/components/table'
import {Loading} from '~/components/loader'

class ConstantCustomFieldViewComponent extends AbstractConstantCustomFieldViewComponent{
    constructor(props){
        super(props)
        this.state ={
            ...this.state,
        }
    }
    render(){
        const {t} = this.props
        return (
            <div className="main-page">
                <Sidebar id="constant" isAccount={true}/>

                <div className="main-content">
                    <Header />
                    <div className="main-head-option">
                        <ul className="list-inline breadcrum clearfix">
                            <li>
                                <a href={route.admin.accounting.menu}>
                                    {t('sidebar:account') } &nbsp; &gt; &nbsp;
                                </a>
                            </li>
                            <li>
                                <a href={route.admin.accounting.constant.menu}>
                                {t('constant:constant')} &nbsp; &gt; &nbsp;
                                </a>
                            </li>
                            <li>{t('constant:customfield')}</li>

                        </ul>
                        <div className='row clearfix'>
                            <div className="col-md-5 float-left">
                                <h5 className="main-title heading5">{t('constant:managecustomfield')}</h5>
                            </div>
                            <div className="col-md-7 calendar-module float-left text-right">
                                <div className="display-inline-block">
                                    <a href={route.admin.accounting.constant.customfield.add} className="main-button">{t('common:addBtn')}</a>
                                </div>
                            </div>
                        </div> 
                    </div>
                
                    <div className="main-form">
                        <Table data={this.state.tableData} />
                        <br />
                    </div>
                </div>

            </div>
        )
    }
}
const ConstantCustomFieldView = withTranslation()(connect(mapStateToProps)
(ConstantCustomFieldViewComponent))

export {ConstantCustomFieldView}
